if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/*
 * Rincelle — ouvre le panier tiroir pour les formulaires personnalisés
 * (bundle et bouton d'ajout), sur mobile comme sur ordinateur.
 */
if (!window.rincelleCustomCartDrawerBound) {
  window.rincelleCustomCartDrawerBound = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;

    const isRincelleBundle = form.matches('.rb-form');
    const isRincelleCustomButton = Boolean(form.querySelector('.bouton-ajout-panier'));
    if (!isRincelleBundle && !isRincelleCustomButton) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    if (form.dataset.drawerSubmitting === 'true') return;

    form.dataset.drawerSubmitting = 'true';
    const errorMessage = form.querySelector('.rb-form__error');
    if (errorMessage) { errorMessage.textContent = ''; errorMessage.hidden = true; }
    if (submitButton) submitButton.disabled = true;

    try {
      const formData = new FormData(form);
      const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(document.activeElement);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: formData
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || 'Impossible d’ajouter le produit au panier.');
      }

      cartDrawer.renderContents(result);
      cartDrawer.classList.remove('is-empty');
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rincelle-custom-form' });
    } catch (error) {
      console.error('Rincelle cart drawer:', error);
      if (errorMessage) {
        errorMessage.textContent = error.message || 'Impossible d’ajouter au panier. Réessaie dans un instant.';
        errorMessage.hidden = false;
      }
    } finally {
      delete form.dataset.drawerSubmitting;
      if (submitButton) submitButton.disabled = false;
    }
  });
}
